import { Badge, Button } from "react-bootstrap";
import backBtn from "../../assets/icons/arrow_left.svg";
import { PaymentData } from "../../types";
import { formatAmount, formatDate, getStatusStyle } from "../../lib/utils";

interface SchoolPaymentDetailsModalProps {
	payment: PaymentData;
	onHide: () => void;
}

const safeJsonParse = (value: string | undefined) => {
	if (!value) return null;
	try {
		return JSON.parse(value);
	} catch {
		return null;
	}
};

const formatMaybeAmount = (amount: number | string | undefined) => {
	if (typeof amount === "number") return formatAmount(amount);
	if (typeof amount === "string" && amount.trim() && !Number.isNaN(Number(amount))) {
		return formatAmount(Number(amount));
	}
	return amount ?? "-";
};

const SchoolPaymentDetailsModal = ({ payment, onHide }: SchoolPaymentDetailsModalProps) => {
	const providerJson = safeJsonParse(payment.provider_response);
	const statusStyle = getStatusStyle(payment.status || "");

	return (
		<>
			<div className="modal-backdrop" onClick={onHide}></div>
			<div className="modal-container">
				<div className="book-details-body">
					<div className="custom-modal-header">
						<div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}>
							<img src={backBtn} alt="back" onClick={onHide} style={{ cursor: "pointer" }} />
							<h4>Payment Details</h4>
						</div>
						<Button onClick={onHide}>Close</Button>
					</div>

					<div className="custom-modal-body">
						<div className="detail-section">
							<div className="book-id mb-4">
								<span style={{ fontWeight: "500" }}>Payment ID</span>
								<span style={{ color: "#A5A5A5" }}>{`#${payment.id}`}</span>
							</div>

							<div className="book-detail">
								<span>Status</span>
								<p>
									<Badge bg={statusStyle.variant} className={statusStyle.className}>
										{statusStyle.text}
									</Badge>
								</p>
							</div>

							<div className="book-detail">
								<span>Amount</span>
								<p>{formatMaybeAmount(payment.amount)}</p>
							</div>

							<div className="book-detail">
								<span>Product</span>
								<p>{payment.product ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Product ID</span>
								<p>{payment.product_id ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>Reference</span>
								<p>{payment.reference ?? "-"}</p>
							</div>

							<div className="book-detail">
								<span>RRR</span>
								<p>{payment.retrieval_reference ?? "-"}</p>
							</div>

							<div className="book-detail mb-0">
								<span>Date Updated</span>
								<p>{payment.updated_at ? formatDate(payment.updated_at) : "-"}</p>
							</div>
						</div>

						<div className="detail-section">
							<div className="book-detail">
								<span>User</span>
								<p>
									{payment.user
										? `${payment.user.first_name ?? ""} ${payment.user.last_name ?? ""}`.trim() || "-"
										: "-"}
								</p>
							</div>
							<div className="book-detail">
								<span>Email</span>
								<p>{payment.user?.email ?? "-"}</p>
							</div>
							<div className="book-detail mb-0">
								<span>Phone Number</span>
								<p>{payment.user?.phone_number ?? "-"}</p>
							</div>
						</div>

						<div className="detail-section">
							<div className="book-detail">
								<span>Provider Response (JSON)</span>
								<pre className="json-box">
									{providerJson ? JSON.stringify(providerJson, null, 2) : (payment.provider_response ?? "-")}
								</pre>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SchoolPaymentDetailsModal;


